import { degreeExtended, SortDirection } from '@common-types';

import { Option } from '@interfaces';
import { INITIAL_VALUES as Initial } from '@interfaces/adminHomePage';

interface DEGREE_ITEM {
  label: string;
  category: string;
  awardLevel: number;
}

export const OTHER_DEGREE_DATA: { [key: string]: DEGREE_ITEM } = {};
export const CERTIFICATE_PROGRAMS_DATA: DEGREE_ITEM[] = [];
export const DOCTORATE_PROGRAMS_DATA: DEGREE_ITEM[] = [];

degreeExtended.forEach((item) => {
  if (item.category === 'Certificate') {
    CERTIFICATE_PROGRAMS_DATA.push(item);
  } else if (item.category === 'Doctorate') {
    DOCTORATE_PROGRAMS_DATA.push(item);
  } else {
    OTHER_DEGREE_DATA[item.category] = item;
  }
});

export const SORT_BY_OPTIONS: Option[] = [
  { value: `CIP,${SortDirection.ASC}`, label: `CIP: ${SortDirection.ASC}` },
  { value: `CIP,${SortDirection.DESC}`, label: `CIP: ${SortDirection.DESC}` },
  { value: `Name,${SortDirection.ASC}`, label: 'Name: A to Z' },
  { value: `Name,${SortDirection.DESC}`, label: 'Name: Z to A' },
];

export const EDIT_MODE_DESCRIPTION =
  'The checked majors are all the majors that will display for students and prospective students looking at your school profile. To hide/show the major, simply uncheck/check the box next to the corresponding major then hit save.';
export const ADD_MODE_DESCRIPTION =
  'The selected areas of study are all the academic fields that will be visible to students and prospective students when they view your school profile. To hide/show the area of study, simply uncheck/check the box next to the corresponding area of study and then save your changes.';

export const INITIAL_VALUES: Initial = {
  associates: [],
  masters: [],
  bachelors: [],
  certificatePrograms: [],
  doctoratePrograms: [],
};

export const FIELD_VALUES: Initial = {
  associates: [3],
  masters: [7],
  bachelors: [5],
  certificatePrograms: [2, 4, 6, 8, 20, 21],
  doctoratePrograms: [17, 18, 19],
};
